import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const CONTACT_CONFIG = {
  phone: {
    icon: 'Phone',
    unavailableIcon: 'PhoneOff',
    titleKey: 'candidates.phoneAvailable',
    unavailableTitleKey: 'candidates.phoneUnavailable',
  },
  linkedin: {
    icon: 'Linkedin',
    titleKey: 'candidates.linkedinAvailable',
    unavailableTitleKey: 'candidates.linkedinUnavailable',
  },
};

const AvailabilityLabel = ({ type, available }) => {
  const { t } = useTranslation();
  const config = CONTACT_CONFIG[type];
  if (!config) return null;

  const title = t(available ? config.titleKey : config.unavailableTitleKey);
  const showSlashOverlay = !available && !config.unavailableIcon;
  const iconName = available ? config.icon : (config.unavailableIcon ?? config.icon);

  return (
    <span
      title={title}
      aria-label={title}
      className={cn(
        'inline-flex items-center justify-center rounded-full border p-1.5',
        available
          ? 'bg-green-100 text-green-800 border-green-200'
          : 'bg-gray-100 text-gray-400 border-gray-200'
      )}
    >
      {showSlashOverlay ? (
        <span className="relative inline-flex">
          <Icon name={config.icon} size={16} strokeWidth={2} />
          <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <span className="block h-[1.5px] w-[140%] bg-current rotate-45 rounded-full" />
          </span>
        </span>
      ) : (
        <Icon name={iconName} size={16} strokeWidth={2} />
      )}
    </span>
  );
};

export default AvailabilityLabel;
